import { Component, OnInit } from '@angular/core';
import { API } from '@config/constants/api.constant';
import { ICardLogConfig, ILogContext, ILogRecord, isDistributorLog } from '@shared/interface/log.interface';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-tab-log',
  styleUrls: ['./tab-log.component.scss'],
  template: ` <app-card-log [config]="logConfig" [context]="logContext" /> `,
})
export class TabLogComponent implements OnInit {
  logConfig!: ICardLogConfig;
  logContext!: ILogContext;

  constructor(private activeRoute: ActivatedRoute) {}

  ngOnInit() {
    this.initLogConfig();
  }

  initLogConfig() {
    const { id, status, tab } = this.activeRoute.snapshot.params;

    this.logContext = {
      id,
      status,
      tab,
    };

    this.logConfig = {
      urlDataApi: API.DISTRIBUTOR.GET_LOG + id,
      emptyStateText: 'Distributor belum memiliki riwayat perubahan.',

      linkGenerator: (record: ILogRecord) => {
        if (!isDistributorLog(record)) return null;
        if (!record.distributor_id) return null;

        return {
          url: `/distributor/detail/log/${record.distributor_id}`,
          label: 'Lihat Detail',
          queryParams: {
            mode: record.status_enum,
            source: 'log',
          },
        };
      },
    };
  }

  protected readonly API = API;
}
